import React, { useState, useEffect, useMemo } from 'react';
import {
  Container,
  Input
} from 'reactstrap';
import { connect } from 'react-redux';
import { ICommissionPaymentTable, IAuthReduxProps } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt, faEye, faFileInvoice, faListAlt } from '@fortawesome/free-solid-svg-icons'
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import PDFLink from '../pdf/PDFLink';
import { useHistory } from 'react-router-dom';
import LinesEllipsis from 'react-lines-ellipsis'

import { DateRangeColumnFilter, NumberRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import { PRIVILEGE } from '../../types/privileges';
import { getCommission_bulletinByIdPromise } from '../../flux/actions/commissionbulletinActions';

const CommissionPaymentTable = ({ 
  linesData,
  setTableData,
  selectedRows,
  setSelectedRows,
  clearFilters,
  setClearFilters,
  showComColumn,
  fromPayment,
  auth
 }: ICommissionPaymentTable) => {
  const [selectedRowsIds, setSelectedRowsIds] = useState(Object())
  // const [skipPageReset, setSkipPageReset] = React.useState(false)
  const skipResetRef = React.useRef(false);
  const alert = useAlert();
  const history = useHistory();

  // useEffect(() => {
  //   console.log("**", selectedRows, selectedRowsIds)
  //   // setSelectedRows(selectedRows);
  // }, [selectedRows]);
  
  const viewCard = (e, id) => {
    if(id !== null && id !== undefined){
      if (e.ctrlKey){
        window.open('/bulletin_commission/' + id, '_blank');
        return;
      }
      history.push({ pathname: `/bulletin_commission/${id}` })
    }
    else
      alert.error(E_ERROR.NO_BULLETIN_WITH_THIS_ID)
  }

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        // Cell: ({ value, row: { original } }) => {
        //   return (<a href={original.id !== null && original.id !== undefined ? (`/bulletin_commission/${original.id}`) : '/#'} onClick={(e) => {
        //     e.preventDefault();
        //     if(original.id !== null && original.id !== undefined)
        //       window.open('/bulletin_commission/' + original.id, '_blank')
        //     else
        //       alert.error(E_ERROR.NO_BULLETIN_WITH_THIS_ID)
        //   }}><button className="openLinkBtn" style={{textAlign: "left"}}>{value}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>)
        // }
      },
      {
        Header: "Commercial",
        id: "Commercial",
        accessor: e => e.bulletinComUser?.LOGIN || "",
        customExportDisplay: `$.bulletinComUser ? $.bulletinComUser.LOGIN : ""`,
        Cell: ({ value }) => value || "-",
        hidden: !showComColumn
      },
      ...(fromPayment ? [{
        Header: "Commission à payer",
        accessor: "left",
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        // customExportDisplay: `(($.commission_bulletin_lines || []).reduce((n, t) => n + Number(t.commission || 0) + Number(t.bonus_malus || 0), 0) || 0) + Number($.bonus_malus || 0)`,
        Cell: (e) => (e.row.original.commission_payments?.length && Number((e.row.original.commission_payments || []).reduce((e, t) => e + Number(t.commission || 0), 0).toFixed(2)) === Number(Number(e.row.original.toPay || 0).toFixed(2))) ? <div className="cardSticker" style={{backgroundColor: "darkgreen"}}>déjà payée</div> : EditableCell({...e, isDouble: true, maximumToShow: Number((e.row.original.commission_bulletin_lines || []).reduce((n, t) => n + (t.commission || 0) + (t.bonus_malus || 0), 0).toFixed(2)) + e.row.original.bonus_malus, maximumLimit: e.row.original.left_table, isPrice: true, ignoreMaximumLimit: false, addInitialValue: true})
      }] : [{
        Header: "Commission",
        accessor: "total",
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        className: "text-center",
        Cell: ({ value }) => <b>{Number(value || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh"}</b>,
      }, {
        Header: "Payé",
        accessor: "paid",
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        className: "text-center",
        Cell: ({ value }) => <b style={{color: "darkgreen"}}>{Number(value || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh"}</b>,
      }, {
        Header: "Reliquat",
        accessor: "left",
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        className: "text-center",
        Cell: ({ value }) => <b style={{color: "darkorange"}}>{Number(value || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh"}</b>,
      }]),
      {
        Header: "Observation",
        accessor: "comment",
        className: "commentCol",
        Cell: ({ value }) => value ? <LinesEllipsis
            text={value}
            title={value}
            maxLine='3'
            trimRight
            basedOn='letters'
          /> : "-"
      },
      {
        Header: "Validée par",
        id: "Validée par",
        accessor: e => e.bulletinUser?.LOGIN || "",
        customExportDisplay: `$.bulletinUser ? $.bulletinUser.LOGIN : ""`,
        Cell: ({ value }) => value || "-",
        // hidden: true
      },
      {
        Header: "Validée le",
        accessor: "createdAt",
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
        customExportDisplay: `$.createdAt ? new Date($.createdAt) : "-"`,
        Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "-",
        // hidden: true
      },
      {
        Header: "Aperçu",
        className: "text-center",
        disableSortBy: true,
        Cell: ({ row: {original} }) => (
          <Container className="actionsContainer">
            {auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS) && <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
              onClick={(e) => viewCard(e, original.id)}
              title="Consultation">
              <FontAwesomeIcon icon={faEye} />
            </button>}
            <PDFLink documentType={"commission"}
              func={async () => getCommission_bulletinByIdPromise(original.id || -1)}
              // data={original}
              download={false}
              buttonText=""
              iconSize="inherit"
              customButtonIcon={faListAlt}
              allowPrintPreview={true}
              htmlTitle="Voir le bulletin des commissions"
              customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace" />
          </Container>
        )
      },
    ],
    [showComColumn, fromPayment]
  );

  const updateMyData = (rowIndex, columnId, value) => {
    // setSkipPageReset(true);
    skipResetRef.current = true;
    setTableData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          }
        }
        return row
      })
    )
  }

  React.useEffect(() => {
    // setSkipPageReset(false);
    skipResetRef.current = false;
  }, [linesData])

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={linesData.map(e => {
          const total = Number((Number((e.commission_bulletin_lines || []).reduce((e, t) => e + Number(t.commission || 0) + Number(t.bonus_malus || 0), 0).toFixed(2)) + Number(e.bonus_malus || 0)).toFixed(2))
          const paid = Number(Number(e.paid || 0).toFixed(2))
          const left = Number((total - paid).toFixed(2))
          return {...e, total, paid, left}
        })} dataName="preparation_paiement" checkBoxChecksAllPages enableCheckBox={!!fromPayment} clearFilters={clearFilters} setClearFilters={setClearFilters} setSelectedRows={setSelectedRows} setSelectedRowsIds={setSelectedRowsIds} isEditable={!!fromPayment} hideSettings={!!fromPayment} updateMyData={updateMyData} skipPageReset={skipResetRef.current}/>
      </Container>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {})(CommissionPaymentTable);
